import React from 'react';
import {Modal} from "react-bootstrap";

export function CardOnlinePaymentDialog({
    show,
    onHide,
                                        }) {
    return(
        <Modal
            show={show}
            onHide={onHide}
            >
            <Modal.Header closeButton>
                <Modal.Title>پرداخت آنلاین</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                مشخصات جهت پرداخت
            </Modal.Body>
            <Modal.Footer>
                <div>
                    <button
                        type={'button'}
                        onClick={onHide}
                        className={'btn btn-light btn-elevate'}>
                        لغو
                    </button>
                    <button
                        type={'button'}
                        className={'btn btn-primary btn-elevate'}
                        >
                        ورود به درگاه
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}